// export interface DeviceInfo {
//   userAgent: string;
//   os: string;
//   browser: string;
//   browserVersion: string;
//   deviceType: string;
//   language: string;
//   screenWidth: number;
//   screenHeight: number;
//   hardwareConcurrency: string | number;
// }

// export function getDeviceInfo(): DeviceInfo {
//   const userAgent = navigator.userAgent;
//   // raw platform (often "MacIntel" on mac)
//   const rawPlatform = navigator.platform;

//   // ----- Viewport dimensions -----
//   const viewportWidth =
//     window.innerWidth ||
//     document.documentElement.clientWidth ||
//     document.body.clientWidth;
//   const viewportHeight =
//     window.innerHeight ||
//     document.documentElement.clientHeight ||
//     document.body.clientHeight;

//   // ----- OS detection -----
//   let os = "unknown";
//   if (rawPlatform.indexOf("Win") !== -1) {
//     os = "Windows";
//   } else if (rawPlatform.indexOf("Mac") !== -1) {
//     // macOS (the browser often reports 'MacIntel' or similar)
//     os = "MacOS";
//   } else if (rawPlatform.indexOf("Linux") !== -1) {
//     os = "Linux";
//   } else if (/Android/.test(userAgent)) {
//     os = "Android";
//   } else if (/iPhone|iPad|iPod/.test(userAgent)) {
//     os = "iOS";
//   }

//   // ----- Browser + version detection -----
//   let browser = "unknown";
//   let browserVersion = "unknown";

//   // Typical patterns in userAgent:
//   // Chrome:  "Chrome/xx.xx.xx.xx"
//   // Firefox: "Firefox/xx.xx"
//   // Safari:  "Version/xx.xx Safari"
//   // Edge:    "Edg/xx.xx"
//   // IE11:    "Trident/7.0; rv:11.0" or "MSIE x.x"

//   if (/Edg\//.test(userAgent)) {
//     browser = "Edge";
//     const match = userAgent.match(/Edg\/([\d.]+)/);
//     if (match?.[1]) {
//       browserVersion = match[1];
//     }
//   } else if (/Chrome/.test(userAgent) && /Google Inc/.test(navigator.vendor)) {
//     browser = "Chrome";
//     const match = userAgent.match(/Chrome\/([\d.]+)/);
//     if (match?.[1]) {
//       browserVersion = match[1];
//     }
//   } else if (
//     /Safari/.test(userAgent) &&
//     /Apple Computer/.test(navigator.vendor)
//   ) {
//     browser = "Safari";
//     // Safari version usually in "Version/xx.xx"
//     const match = userAgent.match(/Version\/([\d.]+)/);
//     if (match?.[1]) {
//       browserVersion = match[1];
//     }
//   } else if (/Firefox/.test(userAgent)) {
//     browser = "Firefox";
//     const match = userAgent.match(/Firefox\/([\d.]+)/);
//     if (match?.[1]) {
//       browserVersion = match[1];
//     }
//   } else if (/MSIE|Trident/.test(userAgent)) {
//     browser = "Internet Explorer";
//     const match = userAgent.match(/(MSIE |rv:)([\d.]+)/);
//     if (match?.[2]) {
//       browserVersion = match[2];
//     }
//   }

//   // ----- Device Type detection -----
//   let deviceType = "desktop"; // default
//   if (/Mobi|Android/i.test(userAgent)) {
//     deviceType = "phone";
//   } else if (
//     /Tablet|iPad/i.test(userAgent) ||
//     (viewportWidth >= 600 &&
//       viewportWidth <= 1024 &&
//       !/Mobi|Android/i.test(userAgent))
//   ) {
//     deviceType = "tablet";
//   }

//   return {
//     userAgent,
//     os, // e.g. "MacOS", "Windows", "Linux", "Android", "iOS"
//     browser, // e.g. "Chrome", "Safari"
//     browserVersion, // e.g. "108.0.5359.99"
//     deviceType,
//     language: navigator.language,
//     screenWidth: viewportWidth, // Viewport width
//     screenHeight: viewportHeight, // Viewport height
//     hardwareConcurrency: navigator.hardwareConcurrency || "unknown",
//   };
// }

export interface DeviceInfo {
  userAgent: string;
  os: string;
  browser: string;
  browserVersion: string;
  deviceType: string;
  language: string;
  screenWidth: number;
  screenHeight: number;
  hardwareConcurrency: string | number;
}

export function getDeviceInfo(): DeviceInfo {
  const userAgent = navigator.userAgent;
  const rawPlatform = navigator.platform;

  // ----- Viewport dimensions -----
  const viewportWidth =
    window.innerWidth ||
    document.documentElement.clientWidth ||
    document.body.clientWidth;
  const viewportHeight =
    window.innerHeight ||
    document.documentElement.clientHeight ||
    document.body.clientHeight;

  // ----- OS detection with version -----
  let os = "unknown";

  if (rawPlatform.indexOf("Win") !== -1) {
    // Windows version from userAgent
    const winMatch = userAgent.match(/Windows NT ([\d.]+)/);
    const winVersionMap: Record<string, string> = {
      "10.0": "Windows 10/11",
      "6.3": "Windows 8.1",
      "6.2": "Windows 8",
      "6.1": "Windows 7",
    };
    if (winMatch?.[1]) {
      os = winVersionMap[winMatch[1]] || `Windows NT ${winMatch[1]}`;
    } else {
      os = "Windows";
    }
  } else if (rawPlatform.indexOf("Mac") !== -1) {
    // macOS - Note: browsers cap version at 10.15.7 for privacy
    // Just show "macOS" instead of fake version
    os = "macOS";
  } else if (rawPlatform.indexOf("Linux") !== -1) {
    os = "Linux";
  } else if (/Android/.test(userAgent)) {
    // Android version
    const androidMatch = userAgent.match(/Android ([\d.]+)/);
    if (androidMatch?.[1]) {
      os = `Android ${androidMatch[1]}`;
    } else {
      os = "Android";
    }
  } else if (/iPhone|iPad|iPod/.test(userAgent)) {
    // iOS version
    const iosMatch = userAgent.match(/OS ([\d_]+)/);
    if (iosMatch?.[1]) {
      const version = iosMatch[1].replace(/_/g, ".");
      os = `iOS ${version}`;
    } else {
      os = "iOS";
    }
  }

  // ----- Browser + version detection -----
  let browser = "unknown";
  let browserVersion = "unknown";

  if (/Edg\//.test(userAgent)) {
    browser = "Edge";
    const match = userAgent.match(/Edg\/([\d.]+)/);
    if (match?.[1]) {
      browserVersion = match[1];
    }
  } else if (/Chrome/.test(userAgent) && /Google Inc/.test(navigator.vendor)) {
    browser = "Chrome";
    const match = userAgent.match(/Chrome\/([\d.]+)/);
    if (match?.[1]) {
      browserVersion = match[1];
    }
  } else if (
    /Safari/.test(userAgent) &&
    /Apple Computer/.test(navigator.vendor)
  ) {
    browser = "Safari";
    const match = userAgent.match(/Version\/([\d.]+)/);
    if (match?.[1]) {
      browserVersion = match[1];
    }
  } else if (/Firefox/.test(userAgent)) {
    browser = "Firefox";
    const match = userAgent.match(/Firefox\/([\d.]+)/);
    if (match?.[1]) {
      browserVersion = match[1];
    }
  } else if (/MSIE|Trident/.test(userAgent)) {
    browser = "Internet Explorer";
    const match = userAgent.match(/(MSIE |rv:)([\d.]+)/);
    if (match?.[2]) {
      browserVersion = match[2];
    }
  }

  // ----- Device Type detection -----
  let deviceType = "desktop";

  if (/Mobi|Android/i.test(userAgent)) {
    deviceType = "phone";
  } else if (
    /Tablet|iPad/i.test(userAgent) ||
    (viewportWidth >= 600 &&
      viewportWidth <= 1024 &&
      !/Mobi|Android/i.test(userAgent))
  ) {
    deviceType = "tablet";
  }

  return {
    userAgent,
    os,
    browser: `${browser} ${browserVersion}`,
    browserVersion,
    deviceType,
    language: navigator.language,
    screenWidth: viewportWidth,
    screenHeight: viewportHeight,
    hardwareConcurrency: navigator.hardwareConcurrency || "unknown",
  };
}
